import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BOProduct } from '@boels/models';
import { TranslocoModule, TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import { BimModelListComponent } from './bim-model-list/bim-model-list.component';

@Component({
  selector: 'boels-product-bim-tab',
  templateUrl: './product-bim-tab.component.html',
  styleUrls: ['./product-bim-tab.component.scss'],
  imports: [TranslocoModule, BimModelListComponent],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['productDetails'],
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductBimTabComponent {
  @Input() componentData: { product$: Observable<BOProduct> };
}
